import { css, html, LitElement } from "lit";
import { customElement } from "lit/decorators.js";

import { Events } from "../constants";

@customElement("restart-button")
export class RestartButton extends LitElement {
	public static styles = css`
		.button {
			background-color: #89612e;
			border: 1px solid #e1bf92;

			padding: 5px 10px;
			margin: 0 0 10px 10px;
			text-transform: uppercase;

			cursor: pointer;
			user-select: none;

			display: flex !important;
			align-items: center;
			gap: 5px;
		}

		.button.active,
		.button:hover {
			background-color: #e1bf92;
		}
	`;

	protected render() {
		return html`<a class="button" @click=${this.restart.bind(this)}
			><svg
				xmlns="http://www.w3.org/2000/svg"
				width="16"
				height="16"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			>
				<path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
				<path d="M3 3v5h5" />
			</svg>
			Restart</a
		>`;
	}

	private restart() {
		// eslint-disable-next-line no-alert
		const confirmation = confirm("Are you sure you want to restart?");
		if (!confirmation) return;

		window.dispatchEvent(new Event(Events.RESTART_GAME));
	}
}
